import { AsyncComponentRender } from '@components/AsyncComponent';
import { createTabs } from '@packages/tabs';
import { TabObject } from '@packages/tabs/lib/TabContainer';

export const TABS: TabObject[] = createTabs([
    ['your-costs', 'Your Pricing and Costs', AsyncComponentRender(() => import('./YourCosts'))],
    ['clients-pricing', 'Clients Pricing', AsyncComponentRender(() => import('./ClientsPricing'))],
]);
